import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SessionService } from "../../../shared/services/session.service";
import { AlertPopupService } from "../../../shared/services/alert-popup.service";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { RegexEnum } from "../../../core/enums/regex.enum";
import { DeleteAcount, UpdateProfile } from "../../../states/auth/auth.actions";
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModal } from 'src/app/shared/components/dialog/dialog.component';
import { Location } from "@angular/common";

@Component({
	selector: 'app-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
	public form: FormGroup;

	constructor(
		private sessionService: SessionService,
		private alertPopupService: AlertPopupService,
		private router: Router,
		private formBuilder: FormBuilder,
		private store: Store,
		private dialog: MatDialog,
		private location: Location
	) {
	}

	ngOnInit(): void {
		this.initializeForm();
		this.patchFormValues()
	}

	initializeForm(): void {
		this.form = this.formBuilder.group({
			title: [null, [Validators.required]],
			firstName: [null, [Validators.required]],
			lastName: [null, [Validators.required]],
			emailId: [null, []],
			mobile: [null, []],
		});
	}

	public markTouchedAndDirty(value: string | boolean, key: string): void {
		this.form.controls[key].markAsTouched();
		if (!value) {
			this.form.controls[key].markAsDirty();
		}
	}

	public onSubmit(form: FormGroup): void {
		try {
			if (form.valid) {
				this.store.dispatch(new UpdateProfile({
					title: form.value.title,
					firstName: form.value.firstName,
					lastName: form.value.lastName,
					emailId: form.value.emailId
				}));
			} else {
				form.markAllAsTouched();
				this.alertPopupService.showWarningAlert('You missed to fill some required fields.');
			}
		} catch (e) {
			this.alertPopupService.showErrorAlert(`${e}`);
		}
	}

	private patchFormValues() {
		const data = this.sessionService.state;

		if (data?.profile) {
			this.form.patchValue({
				title: data.profile.title,
				firstName: data.profile.firstName,
				lastName: data.profile.lastName,
				emailId: (data.profile?.emailId) ? data.profile?.emailId : null,
				mobile: (data.profile?.mobile) ? data.profile?.mobile : null,
			});
		}
	}

	deleteAccount() {
		const confirmationModal = this.dialog.open(ConfirmationModal, {
			width: '500px',
			data: {
				dialogTitle: 'Delete Account',
				dialogMessage: "This will delete your account permanently and we won't be able to recover your data.",
				dailogCancelBtnTitle: 'No',
				dailogSuccessBtnTitle: 'Yes',
				params: null,
				isInput: true
			},
		});

		confirmationModal.componentInstance.onSuccessEvent.subscribe((params) => {
			const data = localStorage.getItem('state');
			if (data) {
				const jsonData = JSON.parse(data);
				console.log(jsonData)
				if (jsonData?.profile?.emailId === params || jsonData?.profile?.mobile == params) {
					this.store.dispatch(new DeleteAcount(params));
					this.dialog.closeAll();
					// this.router.navigate(['/']);
					// this.sessionService.unsetState();
				} else {
					this.alertPopupService.showErrorAlert('Your Email Address Is Invalid');
				}
			}
		});
	}

	backBtnClick() {
		this.location.back();
	}
}
